import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export async function fetchMe() {
  const { data } = await api.get("/auth/me");
  return data;
}

export async function fetchPackages() {
  const { data } = await api.get("/packages");
  return data;
}

export async function fetchProducts() {
  const { data } = await api.get("/products");
  return data;
}

export async function validatePlayer(player_id, category = "diamonds") {
  const { data } = await api.post("/validate-player", { player_id, category });
  return data;
}

export async function createCheckout(payload) {
  const { data } = await api.post("/checkout", payload);
  return data;
}

export async function fetchMyOrders() {
  const { data } = await api.get("/orders");
  return data.orders;
}

export async function fetchOrder(order_id) {
  const { data } = await api.get(`/orders/${order_id}`);
  return data;
}

export async function fetchAdminOrders(status, filters = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  Object.entries(filters).forEach(([k, v]) => v && params.set(k, v));
  const q = params.toString();
  const { data } = await api.get(`/admin/orders${q ? `?${q}` : ""}`);
  return data.orders;
}

export const resellerApi = {
  me: () => api.get("/reseller/me").then((r) => r.data),
  topup: (amount_ars) => api.post("/reseller/topup", { amount_ars }).then((r) => r.data),
  recharge: (payload) => api.post("/reseller/recharge", payload).then((r) => r.data),
  adminList: () => api.get("/admin/resellers").then((r) => r.data),
  adminAdd: (email) => api.post("/admin/resellers", { email }).then((r) => r.data),
  adminRemove: (email) => api.delete(`/admin/resellers/${encodeURIComponent(email)}`).then((r) => r.data),
  adminAdjust: (email, delta, note) => api.post(`/admin/resellers/${encodeURIComponent(email)}/adjust`, { delta, note }).then((r) => r.data),
  adminPrices: (prices) => api.put("/admin/reseller-prices", { prices }).then((r) => r.data),
};

export async function fetchAdminStats() {
  const { data } = await api.get("/admin/stats");
  return data;
}

export async function markProcessing(order_id) {
  const { data } = await api.post(`/admin/orders/${order_id}/process`);
  return data;
}

export async function completeOrder(order_id, admin_note) {
  const { data } = await api.post(`/admin/orders/${order_id}/complete`, { admin_note });
  return data;
}

export async function logout() {
  const { data } = await api.post("/auth/logout");
  return data;
}

export async function fetchRewardsState() {
  const { data } = await api.get("/rewards/state");
  return data;
}

export async function openLootBox() {
  const { data } = await api.post("/rewards/open-box");
  return data;
}

export async function fetchAdminRewards(status) {
  const { data } = await api.get(`/admin/rewards${status ? `?status=${status}` : ""}`);
  return data.rewards;
}

export async function deliverReward(reward_id, admin_note) {
  const { data } = await api.post(`/admin/rewards/${reward_id}/deliver`, { admin_note });
  return data;
}

export async function fetchReviews() {
  const { data } = await api.get("/reviews");
  return data;
}

export async function createReview(rating, text) {
  const { data } = await api.post("/reviews", { rating, text });
  return data;
}

export async function deleteReview(review_id) {
  const { data } = await api.delete(`/reviews/${review_id}`);
  return data;
}

export async function exchangeSession(session_id) {
  const { data } = await api.post("/auth/session", { session_id }, { timeout: 20000 });
  return data;
}
